import { FC } from 'react';
import {
  getBrandsByCategoryId,
  getManuals,
} from 'root/src/commerce/scayle/product-management';
import { ProductManualGridStoryblok } from 'storyblok-types';
import { ProductManualGrid } from 'pages/StoryBlok/ProductManualGrid/ProductManualGrid';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import { IFilterParam } from 'commerce/factFinder/types';
import { Product } from 'commerce/scayle/utils/adapter';

export const ProductManualGridContainer: FC<
  IStoryBlokComponentProps<ProductManualGridStoryblok>
> = async ({ serverProps, blok }) => {
  const appliedBrandIds =
    serverProps.queryParams
      ?.get('substringFilter')
      ?.split(':')[1]
      ?.split(',') || [];

  const initFilters = [
    {
      name: 'brand',
      values: appliedBrandIds.map((brandId) => ({
        value: brandId,
        type: 'brand',
      })),
    },
  ] as unknown as IFilterParam[];

  const { response: brandsFilters } = await getBrandsByCategoryId({
    categoryId: blok.categoryId,
  });

  const { response } = await getManuals({
    categoryId: blok.categoryId,
    appliedBrandIds,
    page: serverProps.page,
  });
  const { entities, pagination } = response || {};

  const products = entities?.map((product) => {
    const parsedProduct = Product.createProduct(product).toJSON();

    return {
      name: parsedProduct.name,
      href: parsedProduct.pdfUrl,
      refKey: parsedProduct.referenceKey,
    };
  });

  if (!pagination) {
    return null;
  }

  return (
    <ProductManualGrid
      products={products || []}
      pagination={pagination}
      brands={brandsFilters || []}
      initFilters={initFilters}
    />
  );
};
